module.exports = __webpack_public_path__ + "static/media/SOL.a61ea1a8.svg";